module.exports = __webpack_public_path__ + "static/media/mari_mobile3.69ad808e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_mobile3.png
// module id = 96
// module chunks = 0